import React from "react";
import "./Festival_Product_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Festival_Product_Card = ({ imgSrc, text, url = `/luxury/products` }) => {
  const navigate = useNavigate();
  return (
    <div className="Festival_Product_Card" onClick={() => navigate(url)}>
      <div className="img_holder">
        <img src={process.env.PUBLIC_URL + imgSrc} className="inner_img" />
      </div>

      <div className="text_container">
        {text ? (
          <>
            <p className="inner_text">{text}</p>
            {/* <FontAwesomeIcon icon={faArrowRight} className="inner_icon" /> */}
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="overlay"></div>
    </div>
  );
};

export default Festival_Product_Card;
